import styled from 'styled-components';

export const DeleteDescription = styled.div`
  border: none;
  padding-bottom: 0;
  font-size: 16px;
  line-height: 22px;
  letter-spacing: -0.2px;
  color: #333333;
  margin-bottom: 32px;
  p {
    margin-bottom: 16px;
  }
`;

export const DivHeader = styled.div`
  align-self: flex-start;
  margin-bottom: 32px;
  font-size: 16px;
  line-height: 22px;
  letter-spacing: -0.2px;
  color: #333333;
  > p {
    margin-bottom: 16px;
    &:last-child {
      margin-bottom: 0;
    }
  }
`;

export const DivBox = styled.div`
  align-self: flex-start;
  width: 100%;
`;

export const DivContent = styled.div``;

export const ItemSignature = styled.div`
  display: flex;
  flex-direction: column;

  &:not(:only-child) {
    border-bottom: 1px solid #dfdfdf;
  }

  &:not(:first-child) {
    margin-top: 48px;
  }

  &:not(:last-child) {
    padding-bottom: 32px;
  }

  > p {
    line-height: 150%;
    letter-spacing: 0;
    color: #333333;
    margin: 0 0 16px 0;

    @media (max-width: 650px) {
      font-size: 14px;
    }
  }

  > a {
    font-size: 16px;
    text-align: end;
    font-weight: 700;
    line-height: 100%;
    letter-spacing: 0;
    text-decoration: none;

    @media (max-width: 650px) {
      font-size: 14px;
    }

    > img {
      margin-left: 10px;
      display: inline;
    }
  }

  &:last-child {
    border-bottom: none;
  }
`;

export const DivProducts = styled(DivContent)`
  border: none;
  box-shadow: none;
  padding: 0;
  width: 100%;

  .divButton {
    display: flex;
    justify-content: center;
    margin-top: 48px;

    @media (max-width: 650px) {
      margin-top: 22px;
      > button {
        width: 100%;
      }
    }
  }

  .reasonButton {
    margin: 0px;
  }
`;

export const List = styled.ul`
  padding-inline-start: 22px;
  margin-top: 16px;

  > li > p {
    margin: 0;
  }

  > li::marker {
    color: #333333;
    font-size: 16px;
    line-height: 22px;
    letter-spacing: -0.2px;
  }
`;

export const TitleProduct = styled.h3`
  font-weight: 700;
  font-size: 16px;
  line-height: 150%;
  letter-spacing: 0;
  margin-bottom: 16px;

  @media (max-width: 650px) {
    font-size: 14px;
  }
`;

export const DivItemGloboAds = styled.div`
  display: flex;
  flex-direction: column;
  font-size: 16px;
  line-height: 150%;

  > p {
    color: #333333;
  }

  > p:not(:first-of-type) {
    margin-top: 32px;
  }

  @media (max-width: 650px) {
    font-size: 14px;
  }
`;

export const DivEmailContent = styled.div`
  width: 100%;
  ul {
    padding-left: 24px;
    margin-top: 0px;
  }

  p:first-child {
    margin-top: 32px;
  }
`;
